<template>
  <div class="toolbar flex align-center justify-space-between">
    <div class="box-left box grow flex">
      <button
        @click="toggleSidebar"
        v-if="menuBurger !== 'right' && termsAccepted"
        class="toggle-sidebar card-base card-shadow--small"
      >
        <i class="mdi mdi-menu"></i>
      </button>

      <img
        class="logo-mini"
        src="@/assets/images/logo-1.png"
        alt="logo"
        @click="logoLink"
      />
    </div>
    <div class="box-right flex align-center">
      <el-dropdown trigger="click" @command="onCommandLang">
        <span class="el-dropdown-link">
          <i
            class="flag-icon"
            :class="{ ['flag-icon-' + $i18n.locale]: true }"
          ></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            command="en"
            class="main-text-color custom-hover"
            :class="{ 'active-flag': $i18n.locale == 'gb' }"
          >
            <i class="flag-icon flag-icon-gb mr-15"></i>EN
          </el-dropdown-item>
          <el-dropdown-item
            command="mk"
            class="main-text-color custom-hover"
            :class="{ 'active-flag': $i18n.locale == 'mk' }"
          >
            <i class="flag-icon flag-icon-mk mr-15"></i>MK
          </el-dropdown-item>
          <el-dropdown-item
            command="bg"
            class="main-text-color custom-hover"
            :class="{ 'active-flag': $i18n.locale == 'bg' }"
          >
            <i class="flag-icon flag-icon-bg mr-15"></i>BG
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

      <button class="fullscreen-button" @click="toggleFullscreen">
        <i class="mdi mdi-fullscreen" v-if="!fullscreen"></i>
        <i class="mdi mdi-fullscreen-exit" v-if="fullscreen"></i>
      </button>

      <template v-if="termsAccepted">
        <span class="username"
          ><router-link to="/my-profile"
            >{{ $t("hi") }}, {{ username }} <br /><span class="inner-span">
              {{ roleName }} @ {{ companyName }}</span
            ></router-link
          ></span
        >
        <el-dropdown trigger="click" @command="onCommand">
          <span class="el-dropdown-link">
            <img :src="avatarImage" class="avatar" alt="avatar" />
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-if="userRoleId !== 2"
              command="my-presence"
              class="main-text-color custom-color"
            >
              <i
                class="mdi mdi-clock-check-outline mr-10"
                :style="{ color: clockColor + ' !important' }"
              ></i>
              {{ $t("my_presence") }}
            </el-dropdown-item>
            <el-dropdown-item
              v-if="userRoleId !== 2"
              command="my-calendar"
              class="main-text-color custom-color"
            >
              <i class="mdi mdi-calendar-month-outline mr-10"></i>
              {{ $t("my_calendar") }}
            </el-dropdown-item>
            <el-dropdown-item
              command="my-profile"
              class="main-text-color custom-color"
            >
              <i class="mdi mdi-account-outline mr-10"></i>
              {{ $t("my_profile") }}
            </el-dropdown-item>
            <button
              class="main-text-color logout-btn w-100 pb-3 pt-3 pr-12"
              @click="logout"
            >
              <span>
                <i class="mdi mdi-logout mr-3"></i>
                <span class="font-logout">{{ $t("logout") }}</span>
              </span>
            </button>
          </el-dropdown-menu>
        </el-dropdown>

        <button
          @click="toggleSidebar"
          v-if="menuBurger === 'right'"
          class="toggle-sidebar toggle-sidebar__right card-base card-shadow--small"
        >
          <i class="mdi mdi-menu"></i>
        </button>
      </template>

      <button
        v-if="!termsAccepted"
        class="main-text-color logout-btn rounded-1 ml-30 mb-2 mr-5 py-2 px-3"
        @click="logout"
      >
        <span> <i class="mdi mdi-logout mr-3"></i> {{ $t("logout") }} </span>
      </button>
    </div>
  </div>
</template>

<script>
import { setLanguage, logout } from "@/globalFunctions/utilityFunctions";

import { instance } from "@/api/apiInstances/apiInstance.js";
import { changeUserLang } from "@/api/apiRequests/globalApi";

export default {
  name: "Toolbar",
  props: ["menuBurger"],
  data() {
    return {
      popoverWidth: 300,
      fullscreen: false,
    };
  },
  computed: {
    avatarImage() {
      return this.$store.getters.getAvatarImage;
    },
    username() {
      return this.$store.getters.username;
    },
    roleName() {
      return this.$store.getters.roleName;
    },
    companyName() {
      return this.$store.getters.companyName;
    },
    clockColor() {
      return this.$store.getters.currentPresenceColor;
    },
    termsAccepted() {
      return this.$store.getters.termsAndConditionsAccepted;
    },
    userRoleId() {
      return this.$store.state.user.roleId;
    },
    roleId() {
      return this.$store.getters.user.roleId;
    },
  },
  methods: {
    logout,
    logoLink() {
      if (this.roleId === 2) {
        if (this.$router.currentRoute.path !== "/dashboard") {
          this.$router.push("/dashboard");
        }
        return;
      }

      if (this.$store.getters.termsAndConditionsAccepted) {
        const currentRoute = this.$router.currentRoute;
        if (currentRoute.path !== "/my-presence") {
          this.$router.push("/my-presence");
        }
      }
    },
    onCommandLang(lang) {
      //if it needs to go to another route when the language changes
      if (lang.charAt(0) === "/") {
        this.onCommand(lang);
      } else {
        this.switchLanguage(lang);
      }
    },
    onCommand(path) {
      if (path === this.$route.name) {
        return;
      }
      this.$router.push({ name: path });
    },
    switchLanguage(lang) {
      //console.log("switching lang to:",lang);
      changeUserLang(instance, { user_lang: lang })
        .then((response) => {
          // console.log(response);

          //console.log("response.data.message:", response.data.message);

          if (lang == "en") lang = "gb"; //we use gb because with 'en' the translation for some reason it does not work
          this.$i18n.locale = lang;
          setLanguage(lang); // Store the selected language in local storage

          // Translate the title using vue-i18n
          const translatedTitle = this.$t(this.$route.meta.title);

          // Set the document title to the translated title
          if (this.$route.meta.title != "not_found") {
            document.title = "AbSent | " + translatedTitle;
          } else {
            document.title = "404 | " + translatedTitle;
          }

          // console.log(this.$t(response.data.message));

          //console.log('Changed lang to:', this.$i18n.locale);
        })
        .catch((error) => {
          // console.log(error);
        });
    },
    toggleSidebar() {
      this.$emit("toggle-sidebar");
    },
    resizePopoverWidth() {
      if (window.innerWidth <= 1240) {
        this.popoverWidth = 250;
      } else {
        this.popoverWidth = 300;
      }
    },
    toggleFullscreen() {
      this.$fullscreen.toggle(document.querySelector("body"), {
        wrap: false,
        callback: () => {
          this.fullscreen = this.$fullscreen.getState();
        },
      });
    },
  },

  mounted() {
    this.fullscreen = this.$fullscreen.getState();
    this.resizePopoverWidth();
    window.addEventListener("resize", this.resizePopoverWidth);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizePopoverWidth);
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/_variables";
@import "../assets/scss/_mixins";
.el-popper {
  padding-bottom: 0px;
}
.logout-btn {
  border: none;
  background-color: rgba(89, 29, 241, 0.1);
  color: $text-color-purple;
  font-size: 15px;
  margin-top: 8px;
}

.logout-btn:hover {
  background-color: $text-color-purple;
  color: white;
}
.toolbar {
  width: 100%;
  height: 100%;
  padding: 0 10px;
  box-sizing: border-box;

  .username {
    font-size: 15px;
    margin-left: 20px;
    font-weight: bold;
    @include text-bordered-shadow();

    a {
      color: $main-text-color;
      text-decoration: none;

      &:hover {
        color: $main-text-color;
      }
    }
  }

  .avatar {
    border-radius: 50%;

    object-fit: cover; /* Maintain aspect ratio and cover the container */
    background-color: white;

    width: 35px;
    height: 35px;
    border: 1px solid #fff;
    margin-left: 20px;
    box-sizing: border-box;
    display: block;
    cursor: pointer;
    box-shadow: 0 2px 5px 0 rgba(49, 49, 93, 0.1),
      0 1px 2px 0 rgba(0, 0, 0, 0.08);
    transition: box-shadow 0.5s;

    &:hover {
      box-shadow: 0px 3px 10px 0 rgba(49, 49, 93, 0.08),
        0px 2px 7px 0 rgba(0, 0, 0, 0.08);
    }
  }

  .toggle-sidebar {
    border: 1px solid transparent;
    height: 32px;
    min-height: 32px;
    line-height: 32px;
    width: 32px;
    min-width: 32px;
    max-width: 32px;
    box-sizing: border-box;
    text-align: center;
    margin: 0;
    outline: none;
    margin-right: 5px;
    font-size: 24px;
    padding: 0;
    cursor: pointer;
    display: inline-block;
    color: $text-color;
    background: white;
    display: none;
    opacity: 0;
    transition: all 0.5s;

    &__right {
      margin-right: 0px;
      margin-left: 5px;
    }

    &:hover,
    &:focus,
    &:active {
      color: $main-text-color;
      border-color: $text-color-purple;
    }
  }

  .fullscreen-button {
    font-size: 24px;
    cursor: pointer;
    outline: none;
    padding: 0;
    background: transparent;
    border: none;
    margin-left: 20px;

    color: transparentize($text-color, 0.7);
    @include text-bordered-shadow();

    &:hover {
      color: $text-color-purple;
    }
  }

  .logo-mini {
    width: 32px;
    height: 32px;
    display: none;
  }

  .el-dropdown {
    .flag-icon {
      box-shadow: 0 2px 5px 0 rgba(49, 49, 93, 0.1),
        0 1px 2px 0 rgba(0, 0, 0, 0.08);
      cursor: pointer;
      border: 1px solid lighten($background-color, 20%);
      background-color: lighten($background-color, 20%);
    }
  }

  i.mdi.mdi-menu {
    color: $text-color-purple;
  }
  i.mdi.mdi-menu:hover {
    color: $text-color-purple;
  }
}

.mdi-calendar-month-outline {
  color: $text-color-purple;
}
.mdi-account-outline {
  color: #1dc9b7;
}
.custom-color:hover {
  color: $text-color-purple;
}
.custom-color {
  padding-left: 30px !important;
  padding-right: 40px !important;
  padding-top: 8px;
  padding-bottom: 8px;
}

.active-flag {
  color: $text-color-purple;
  font-weight: bold;
}

.custom-hover:hover {
  color: $text-color-purple;
}
.inner-span {
  font-size: 12px;
}
@media (max-width: 1241px) {
  .toolbar {
    .username {
      font-size: 13px;
    }
    .inner-span {
      font-size: 11px;
    }
  }
}
@media (max-width: 1240px) {
  .toolbar {
    padding: 0 10px;

    .toggle-sidebar {
      display: block;
      opacity: 1;
    }

    .fullscreen-button {
      display: none;
    }

    .logo-mini {
      display: inherit;
    }
  }
}

@media (max-width: 650px) {
  .toolbar {
    .username {
      font-size: 13px;
    }
    .inner-span {
      font-size: 11px;
    }
  }
}
@media (max-width: 573px) {
  .toolbar {
    .username {
      font-size: 11px;
    }
    .inner-span {
      font-size: 9px;
    }
  }
}
@media (max-width: 400px) {
  .toolbar {
    .username {
      font-size: 9px;
    }
    .inner-span {
      font-size: 6px;
    }
  }
}
@media (max-width: 337px) {
  .toolbar {
    .username {
      font-size: 7px;
    }
    .inner-span {
      font-size: 4px;
    }
  }
}
@media (max-width: 273px) {
  .toolbar {
    .username {
      font-size: 6px;
    }
    .inner-span {
      font-size: 3px;
    }
  }
}
</style>
